require('./join-call-template.html');

angular.module('bbl.module.joinCall', [])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/join-call/:token?', {
      templateUrl: 'join-call-template.html',
      controller: 'JoinCallController',
      joinCallRoute: true,
      invitedLayout: true,
      particularBrand: true
    });
  }])
  .controller('JoinCallController', [
    '$scope', '$routeParams', '$http', 'PusherUpdates', '$location', 'CallManager',
    joinCallController
  ]);

function joinCallController($scope, $params, $http, PusherUpdates, $location, CallManager) {
  PusherUpdates.initConnection();

  if($location.search().bid) {
    PusherUpdates.subscribeTo($location.search().bid);
  }

  function getTokenData(token) {
    return $http.get('/bridges/api/v1/get-token-data/' + token + '/?format=json')
    .then(function(response) {
      var data = response.data, call = data.call;

      return {
        company: call.company_name,
        bridge_number: call.number,
        friendly_number: call.friendly_number,
        date: call.date,
        plivo_username: call.plivo_username,
        plivo_password: call.plivo_password,
        brand_logo: (call.brand_logo || 'assets/images/logo@2x.png'),
        brand_tagline: call.bridge_title || call.bridge_description || call.brand_tagline,
        service_provider: call.service_provider,
        jfb_url: call.jfb_url,
      };
    });
  }

  getTokenData($params.token).then(function(callData) {
    CallManager.init(callData.plivo_username, callData.plivo_password);

    $scope.$root.particularBrandLogo = callData.brand_logo;
    $scope.$root.particularBrandTagline = callData.brand_tagline;

    $scope.JOIN = angular.copy(callData);
    $scope.confReady = true;

    $scope.startConference = CallManager.createCall.bind(0, $scope.JOIN);
  });

  $scope.getCall = CallManager.getCall.bind(0);
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/join-call/join-call.module.js
 ** module id = 316
 ** module chunks = 0
 **/